import React from "react";
import {
  List,
  Datagrid,
  TextField,
  Filter,
  ReferenceField,
  SelectInput,
  FunctionField,
} from "react-admin";
import CompanyField from "../components/fields/CompanyField";
import RenderDate from "../components/fields/RideDateField";
import CustomIcon from "../components/CustomIcon";
import { styles } from "../styles";
import arrow from "../images/arrow.svg";

const MatchesFilter = (props) => (
  <Filter {...props}>
    <SelectInput
      alwaysOn
      label="By date"
      addLabel
      source="createdAt"
      choices={[
        { id: "today", name: "today" },
        { id: "week", name: "this week" },
      ]}
      style={styles.input}
    />
  </Filter>
);

const renderDate = (ride) => <RenderDate ride={ride} type="createdAt" />;

const Row = ({ children }) => (
  <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
    {children}
  </div>
);

const PlaceName = ({ children }) => <div style={styles.title}>{children}</div>;

const renderRide = (ride) => (
  <Row>
    <div>
      <PlaceName>{ride.originName}</PlaceName>
      <RenderDate ride={ride} type="startDatetime" />
    </div>
    <CustomIcon src={arrow} />
    <div>
      <PlaceName>{ride.destinationName}</PlaceName>
      <RenderDate ride={ride} type="endDatetime" />
    </div>
  </Row>
);

export default (props) => (
  <List
    {...props}
    title="All matches"
    perPage={25}
    filters={<MatchesFilter />}
    bulkActionButtons={false}>
    <Datagrid>
      <TextField source="_id" sortable={false} style={styles.title} />
      <ReferenceField
        label="Request"
        source="request"
        reference="admin/requests"
        linkType={false}>
        <FunctionField render={renderRide} />
      </ReferenceField>
      <ReferenceField
        label="Empty ride"
        source="shadow"
        reference="admin/shadows"
        linkType={false}>
        <FunctionField render={renderRide} />
      </ReferenceField>
      <FunctionField
        label="Created at"
        sortBy="createdAt"
        render={renderDate}
      />
      <ReferenceField
        label="Seller"
        source="shadowCompanyId"
        reference="admin/companies"
        linkType={false}>
        <FunctionField render={CompanyField} />
      </ReferenceField>
      <ReferenceField
        label="Request"
        source="requestCompanyId"
        reference="admin/companies"
        linkType={false}>
        <FunctionField render={CompanyField} />
      </ReferenceField>
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/matches/List.js